import { render, staticRenderFns } from "./EnvioBodegaCentral.vue?vue&type=template&id=af32a018&scoped=true&"
import script from "./EnvioBodegaCentral.vue?vue&type=script&lang=js&"
export * from "./EnvioBodegaCentral.vue?vue&type=script&lang=js&"
import style0 from "./EnvioBodegaCentral.vue?vue&type=style&index=0&id=af32a018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af32a018",
  null
  
)

export default component.exports